import { useFormContext } from "react-hook-form";
import { Card, CardHeader, CardContent } from "../ui/card";
import { cn } from "@/lib/utils";
import useUser from "@/lib/queries/user/useUser";
import Loading from "../Loading";
import { useStytchSession } from "@stytch/react";
import GenerateButton from "./GenerateButton";
import { motion } from "motion/react";
import { TooltipProvider } from "../ui/tooltip";
import { useTranslation } from "react-i18next";

function SubmitCard({
  isLoading,
  isSuccess,
  sticky = false,
}: {
  isLoading: boolean;
  isSuccess: boolean;
  sticky?: boolean;
}) {
  const { t } = useTranslation("common");
  const form = useFormContext();
  const stytchSession = useStytchSession();
  const { data: user, isLoading: isUserLoading } = useUser({
    enabled: stytchSession.session !== null,
  });

  // Explicitly watch form fields at the component level
  const subject = form.watch("subject");
  const fileUrls = form.watch("fileUrls") ?? [];
  if (isUserLoading) {
    return <Loading className={cn("h-48 bg-lighter-grey")} />;
  }

  const hasSubject = (subject && subject !== "") || fileUrls.length > 0;
  const isGenerateDisabled = !hasSubject;

  return (
    <TooltipProvider>
      {/* {!isGenerateDisabled ? ( */}
      <motion.div
        initial={{ y: 200, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 200, opacity: 0 }}
        transition={{ duration: 0.25, ease: "easeOut" }}
        className={cn(
          sticky
            ? "shadow-[0_-2px_8px_-2px_rgba(0,0,0,0.08)] bg-very-light/95 backdrop-blur supports-[backdrop-filter]:bg-very-light/80"
            : "",
          "w-full"
        )}
      >
        <Card
          className={cn(
            "pt-4 pb-1.5 px-4 bg-very-light rounded-none @container border-none border-t"
          )}
        >
          <CardHeader className="p-0 text-center">
            <h1 className="text-card-title">
              {isSuccess ? t("submit.generated") : t("submit.readyQuestion")}
            </h1>
          </CardHeader>

          <CardContent className="flex flex-col items-center justify-center gap-2 p-0 mt-2 md:mt-4">
            <GenerateButton
              isLoading={isLoading}
              isSuccess={isSuccess}
              isDisabled={isGenerateDisabled}
              authStatus={{
                isLoggedIn: stytchSession.session !== null,
                subscribed: user?.subscribed ?? false,
                hasCredits: import.meta.env.DEV || (user?.creditsRemaining ?? 0) > 0,
              }}
              creditsRemaining={user?.creditsRemaining ?? 0}
              creditsMax={user?.creditsMax ?? 0}
            />
          </CardContent>
        </Card>
      </motion.div>
      {/* ) : null} */}
    </TooltipProvider>
  );
}

export default SubmitCard;
